import { useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeBookReportBest } from './HomeBookReportBest';
import { HomeReadingPhotoBest } from './HomeReadingPhotoBest';
import { HomeReadingPictureBest } from './HomeReadingPictureBest';
import { HomeYoutubeBest } from './HomeYoutubeBest';
          
export const HomeReadingBest = ()=>{
//   const [isPending, startTransition] = useTransition();
  const [tab, setTab] = useState('picture');

  const selectTab = (e, tabName)=>{
    setTab(tabName);
    // startTransition(()=>{
    //   setTab(tabName);
    // });
    e.preventDefault();
  }
  return (
    <div className="main_section4">
      <div className="main_tab_area">
        <div className="tab_menu">
          <ul>
            <li className={`tab1 tabMenu ${tab==='picture'?'on':''}`} id="tabMenu_1">
              <Link to="#" onClick={(e)=>{selectTab(e, 'picture');}}><span>우수 <br />독서화</span><img className="tab_icon" src={`${process.env.PUBLIC_URL}/static/images/main/main_tab_bestPicture_icon.png`} alt=""/></Link>
            </li>
            <li className={`tab2 tabMenu ${tab==='photo'?'on':''}`} id="tabMenu_2">
              <Link to="#" onClick={(e)=>{selectTab(e, 'photo');}}><span>우수 <br />독서사진</span><img className="tab_icon" src={`${process.env.PUBLIC_URL}/static/images/main/main_tab_bestPhoto_icon.png`} alt=""/></Link>
            </li>
            <li className={`tab3 tabMenu ${tab==='report'?'on':''}`} id="tabMenu_3">
              <Link to="#" onClick={(e)=>{selectTab(e, 'report');}}><span>우수 <br />독서감상문</span><img className="tab_icon" src={`${process.env.PUBLIC_URL}/static/images/main/main_tab_bestReport_icon.png`} alt=""/></Link>
            </li>
            <li className={`tab4 tabMenu ${tab==='video'?'on':''}`} id="tabMenu_4">
              <Link to="#" onClick={(e)=>{selectTab(e, 'video');}}><span>우수 <br />독서영상</span><img className="tab_icon" src={`${process.env.PUBLIC_URL}/static/images/main/main_tab_bestYoutube_icon.png`} alt=""/></Link>
            </li>
          </ul>
        </div>
        <div className="best_reading">
          
              {tab==='picture' && 
              <div className="tab_cont tab_cont1" id="tab1">
                <HomeReadingPictureBest />
              </div>
              }
              {tab==='photo' && 
                <div className="tab_cont tab_cont2" id="tab2">
                  <HomeReadingPhotoBest />
                </div>
                }
              {tab==='report' && 
              <div className="tab_cont tab_cont3" id="tab3">
                <HomeBookReportBest />
              </div>
              }
              { tab==='video' && 
              <div className="tab_cont tab_cont4" id="tab4">
                <HomeYoutubeBest />
              </div>
              }
        </div>
      </div>
    </div>
  );
}